import { useForm } from "react-hook-form";
import RadioGroup from "../../Components/CommonCommponents/RadioGroup";
import Input from "../../Components/CommonCommponents/Input";
import { useEffect } from "react";
import { Button } from "antd";
import Select from "../../Components/CommonCommponents/select/Select";
import AuthService from "../../Service.js/authService";
import { useState } from "react";
import DatePicker from "../../Components/CommonCommponents/DatePicker";
import CandodateService from "../../Service.js/CandidateService";
import toast from "react-hot-toast";
import { dateConverter } from "../../Components/Utilities/util";
import dayjs from "dayjs";

const AddCertification = (props) => {
  console.log("props", props);
  const {
    register,
    control,
    setValue,
    setError,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();
  const [certification, setCertification] = useState();
  const [certficationById, setCertificationById] = useState();

  const ANSWER_OPTIONS = [
    { label: "Full time", value: "true" },
    { label: "Part time", value: "false" },
    { label: "Correspondence/Distance learning", value: "false" },
  ];

  const getInfo = async () => {
    await CandodateService.getCertificationById(props.certificationId)
      .then(
        (oResponse) => {
          console.log("oResponseccc", oResponse.data.data);
          setCertificationById(oResponse.data.data);
          getData(oResponse.data.data);
        },
        (error) => {
          console.log("loginError", error);
        }
      )
      .catch((err) => {
        console.log(err);
      });
  };

  const getData = (data) => {
    setValue("certification", data?.certification_name);
    setValue("college", data?.college);
    setValue(
      "course_start_date",
      data?.course_start_date ? dayjs(data?.course_start_date) : ""
    );
    setValue(
      "course_completed_date",
      data?.course_completed_date ? dayjs(data?.course_completed_date) : ""
    );
    setValue("still_pursuing", data?.still_pursuing);
  };
  useEffect(() => {
    getInfo();
    getData();
  }, [props.certificationId]);

  const certificationInfo = async () => {
    await CandodateService.getCertificationDetails()
      .then((response) => {
        console.log("response", response.data.data);
      })
      .catch((error) => {});
  };
  const sendData = async (data) => {
    const optionCertifications = data.certification.value;
    // const date = dateConverter(data.course_start_date);
    // const course_start_date = date.convertedValue;
    // const date2 = dateConverter(data.course_completed_date);
    // const course_completed_date = date2.convertedValue;
    // data["course_start_date"] = course_start_date;
    // data["course_completed_date"] = course_completed_date;
    data["course_start_date"] = dayjs(data.course_start_date).format('YYYY-MM-DD');
    data["course_completed_date"] = dayjs(data.course_completed_date).format('YYYY-MM-DD');
    data["certification"] = optionCertifications;
    await CandodateService.addCertification(data)
      .then(
        (oResponse) => {
          console.log("oResponse", oResponse);
          toast.success("Successfully Added!");

          props.close();
          certificationInfo();
        },
        (error) => {
          console.log("loginError", error);
        }
      )
      .catch((err) => {
        console.log(err);
        toast.error("Failed To Add");
      });
  };
  const handleCertificationsearch = async (value) => {
    await AuthService.certificationDetails(value)
      .then((response) => {
        setCertification(response.data.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  console.log("testf", certification);

  const updateData = async (data) => {
    console.log("certification", data);
    // const date = dateConverter(data.course_start_date);
    // const course_start_date = date.convertedValue;
    // const date2 = dateConverter(data.course_completed_date);
    // const course_completed_date = date2.convertedValue;
    // data["course_start_date"] = course_start_date;
    // data["course_completed_date"] = course_completed_date;
    data["course_start_date"] = dayjs(data.course_start_date).format('YYYY-MM-DD');
    data["course_completed_date"] = dayjs(data.course_completed_date).format('YYYY-MM-DD');
    data["certification"] =
      data.certification.value !== undefined
        ? data?.certification?.value
        : certficationById?.certification;

    await CandodateService.updateCertification(data, props.certificationId)
      .then(
        (oResponse) => {
          console.log("oResponse", oResponse);
          toast.success("Successfully Updated!");

          props.close();
          certificationInfo();
        },
        (error) => {
          console.log("loginError", error);
        }
      )
      .catch((err) => {
        console.log(err);
        toast.error("Failed To Add");
      });
  };
  const onSubmit = async (data) => {
    if (props.certificationId) {
      updateData(data);
    } else {
      sendData(data);
    }
  };
  return (
    <div className="w-full pb-6 p-4 flex">
      <form className=" w-full" onSubmit={handleSubmit(onSubmit)}>
        <div class="px-2">
          <div class="flex -mx-2 md:flex-row flex-col">
            <div class="w-full px-4">
              <Select
                onSearch={(value) => handleCertificationsearch(value)}
                name="certification"
                placeholder="Search Certification"
                label="Name"
                control={control}
                options={certification?.results?.map((oOption) => {
                  return {
                    value: oOption.option_id,
                    label: oOption.name,
                  };
                })}
                showSearch
                //  options={skillData}
                rules={{
                  required: "This field is required",
                }}
                className="multiSelect"
              />
            </div>
          </div>
          <div class="flex -mx-2 md:flex-row flex-col">
            <div class="w-full px-4">
              <Input
                name="college"
                label="Issuing organization"
                control={control}
                rules={{
                  required: "This field is required",
                }}
                className="h-12 "
              />
            </div>
          </div>
          <div class="flex -mx-2 md:flex-row flex-col">
            <div class="w-full px-4">
              <DatePicker
                label="Issue date"
                name="course_start_date"
                noTextInput
                showToday
                rules={{
                  required: "Please Choose a Date",
                }}
                control={control}
                placeholder="Select"
                // disablePreviousDays
                className="h-12"
                disableFutureDays={true}
              />
            </div>
          </div>
          <div class="flex -mx-2 md:flex-row flex-col">
            <div class="w-full px-4">
              <DatePicker
                label="Expiration date"
                name="course_completed_date"
                noTextInput
                showToday
                control={control}
                placeholder="Select"
                // disablePreviousDays
                className="h-12"
                disableFutureDays={true}
              />
            </div>
          </div>
        </div>
        <div className="flex flex-wrap justify-end mt-6 px-4">
          <Button
            htmlType="submit"
            type="submit"
            className="bg-[#000000] text-white text-base rounded-3xl"
          >
            Save
          </Button>
        </div>
      </form>
    </div>
  );
};

export default AddCertification;
